import React, { useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { useDivDimensions } from '../../utils/WindowSize'
import { createMap } from '../Charts/D3/helpers'

const Container = props => {
    const
        containerRef = useRef(),
        // { w, h } = useDivDimensions(containerRef),
        { id, pathsDispatch, width, height, data, renderChart, children, onClick } = props

    useEffect(() => {
       createMap({
           id,
           data,
           width,
           height
       }, renderChart)
    },[!pathsDispatch.isLoading && data])
    return (
        <div id={ id } ref={ containerRef }>
            <svg width={ width } height={ height }>
                <g width={ width } height={ height } onClick={onClick}>
                    { children }
                </g>
            </svg>
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => ({
        pathsDispatch: dispatch.paths
    })
)

export default connect(mapStateToProps)(Container)
